import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-config.service.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  private uri = ``;

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService,
  ) {
    this.uri = this.appConfigService.apiBaseUrl;
  }

  GetInfoSites(method):Observable<any>{
    return this.http.post(this.uri +method,{})
  }

  GetInfoNewFormat(method:any):Observable<any>{
    return this.http.post(this.uri + '/FlexIntegration',{ "method":method})
  }

  GetCustomerByName(name) {
    return this.http.post<any>(this.uri + '/Customer/GetCustomerListByName', { CustomerName: name });
  }

  GetCustomerCEByName(name){
    return this.http.post(this.uri + '/FlexIntegration',{ "method": 'Get_CustomerCE_ByName', name: name});
  }

  GetCustomerWithCreditListByName(name) {
    return this.http.post<any>(this.uri + '/Customer/GetCustomerWithCreditListByName', { CustomerName: name });
  }
  
  GetCustomerList() {
    return this.http.post<any>(this.uri + '/Customer/GetCustomerList', {});
  }

  GetCustomerFilters(model) {
    return this.http.post<any>(this.uri + '/Customer/GetCustomerPage', model);
  }

  GetCustomerFilterUrl() {
    return this.uri + '/Customer/GetCustomerPage';
  }

  GetCustomerType() {
    return this.http.post<any>(this.uri + '/CustomerType', {});
  }
  GetCustomerTaxes(){
    return this.http.post<any>(this.uri + '/Customer/GetCustomerTaxes', {});
  }

  GetCountries() {
    return this.http.post<any>(this.uri + '/Country', {});
  }

  GetCustumerById(ids: number) {
    return this.http.post<any>(this.uri + '/Customer', {id: ids});
  }
  GetActivitiesByCustumer(id) {
    return this.http.post<any>(this.uri + '/Customer/GetCustomerActivity', {CustomerId: id});
  }
  GetAssocByCustumer(id) {
    return this.http.post<any>(this.uri + '/Customer/GetAssociatedPeople', {CustomerId: id});
  }

  PostNewCustumer(data) {
    return this.http.post<any>(this.uri + '/Customer/InsertCustomer', data);
  }
  PostNewActivityByCustumer() {

  }
  EditCustumerById(data) {
    // editCustomer
    return this.http.post<any>(this.uri + '/Customer/InsertCustomer', data);
  }
  /**
   * Opntiosn for Activity Empleoyes
   */
  GetCustomerActivityEmployeesFilter(data) {
    return this.http.post<any>(this.uri + '/Activity', data);
  }
  GetCustomerActivityEmployees() {
    return this.http.post<any>(this.uri + '/Customer/GetCustomerActivityEmployees', {});
  }
  GetCustomerActivityType() {
    return this.http.post<any>(this.uri + '/Customer/GetCustomerActivityType', {});
  }

  GetCustomerSalesRegion() {
    return this.http.post<any>(this.uri + '/Customer/GetCustomerSalesRegion', {});
  }

  PostInsertUpdateCustomerActivity(data){
    return this.http.post<any>(this.uri + '/Customer/InsertUpdateCustomerActivity', data);
  }
    /**
   * Associate People
   */
  GetCustomerOportunityInfluence() {
    return this.http.post<any>(this.uri + '/Customer/GetCustomerOportunityInfluence', {});
  }
  GetCustomerBuyerType() {
    return this.http.post<any>(this.uri + '/Customer/GetCustomerBuyerType', {});
  }
  GetContactsPeople() {
    return this.http.post<any>(this.uri + '/Contacts/Get_AllContacts', {});
  }
  GetAssocitePeople(id){
    return this.http.post<any>(this.uri + '/Customer/GetCustomerContacts',  {CustomerId: id});
  }
  PostInsertCustomerContacts(data){
    return this.http.post<any>(this.uri + '/Customer/InsertCustomerMultipleContacts', data);
  }
  EditInsertCustomerContacts(data){
    return this.http.post<any>(this.uri + '/Customer/InsertCustomerContacts', data);
  }

  deleteNewContac(id){
    return this.http.post<any>(this.uri + '/Customer/DeleteCustomerToContacts', {id: id});  
  }
  deleteCustumer(id){
    return this.http.post<any>(this.uri + '/Customer/DeleteCustomer', {CustomerId: id});
  }

}
